import semverGreatherThanOrEqual from 'semver/functions/gte';

const VALID_SEMVER = /^(\d+\.\d+\.\d+(-\w+)?)/;

const suffixCorrectVersion = (value: string) => {
    const splitValue = (value ?? '').split('.');
    if (splitValue.length < 3) {
        return splitValue.length === 2 ? [...splitValue, '0'].join('.') : [...splitValue, '0', '0'].join('.');
    }
    return value;
};

const getValidSemver = (value: string | undefined) => {
    const targetValue = suffixCorrectVersion(value ?? '');
    return (targetValue?.match(VALID_SEMVER) ?? [])[0];
};

export const isEqualOrHigherVersion = (versionToCheckAgains: string | undefined, targetSemVer: string) => {
    const appVersionNormalized = getValidSemver(versionToCheckAgains);
    if (!appVersionNormalized || appVersionNormalized.length === 0) return false;

    return semverGreatherThanOrEqual(appVersionNormalized, targetSemVer);
};
